
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-library/[slug]",
      function () {
        return require("private-next-pages/content-library/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-library/[slug]"])
      });
    }
  